import HelpIcon from "@mui/icons-material/Help";
import AppBar from "@mui/material/AppBar";
import IconButton from "@mui/material/IconButton";
import Toolbar from "@mui/material/Toolbar";
import Tooltip from "@mui/material/Tooltip";
import Typography from "@mui/material/Typography";

import { Box } from "@mui/material";
import { useTranslation } from "react-i18next";
import { useJoyride } from "../../context/JoyrideContext";
import { useAuth } from "../../features/auth/AuthContext";
import SignOut from "../../features/auth/signOut";
import { isTestingCAFeatureEnabled } from "../../utils/testing-feature";
import { CompanionHealthCheck } from "../companion-app/companion-health-check";
import { LangSwitcher } from "../lang-switcher";
import { SupportEmail } from "../support-email";

function TopMenu() {
	const { user } = useAuth();
	const { t } = useTranslation();
	const { startJoyride } = useJoyride();

	return (
		<AppBar
			position="sticky"
			sx={{
				background: "#F2F2F2",
				boxShadow: "none",
				height: "49px",
			}}
		>
			<Toolbar
				sx={{
					display: "flex",
					justifyContent: "space-between",
					position: "relative",
				}}
				variant="dense"
			>
				<Box
					sx={{
						mr: "20px",
						display: "flex",
						alignItems: "center",
						gap: "16px",
					}}
				>
					{isTestingCAFeatureEnabled(user.companyId) && (
						<CompanionHealthCheck pollIntervalMs={3000} />
					)}
					<SupportEmail />
				</Box>
				<Box
					sx={{ display: "flex", justifyContent: "end", position: "relative" }}
				>
					<Box sx={{ mr: "20px" }}>
						<LangSwitcher />
					</Box>
					<SignOut />
					<Tooltip
						title={
							<Typography variant="p" sx={{ fontSize: "9pt" }} component="span">
								{t("show_tour_guide")}
							</Typography>
						}
						placement="bottom"
					>
						<IconButton
							aria-label="guide"
							size="small"
							onClick={startJoyride}
							sx={{ ml: "20px" }}
						>
							<HelpIcon fontSize="small" />
						</IconButton>
					</Tooltip>
				</Box>
			</Toolbar>
		</AppBar>
	);
}
export default TopMenu;
